import { useState } from "react"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "@f2e/ui/components/base"

import { useToast } from "@/hooks"
import { usePasswordResetRequestApi } from "@/hooks/api/account"
import { getAuthErrorMessage } from "@/lib/authErrors"

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { alertToast } = useToast()
  const { fetchFn: requestReset } = usePasswordResetRequestApi()
  const [email, setEmail] = useState("")
  const [submittedEmail, setSubmittedEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async () => {
    const normalizedEmail = email.trim()
    if (!normalizedEmail) {
      alertToast({
        title: t("common.auth.reset.errors.title"),
        description: t("common.auth.reset.errors.emailRequired"),
      })
      return
    }

    try {
      await requestReset({
        jsonBody: { email: normalizedEmail },
      })
      setSubmittedEmail(normalizedEmail)
      setSubmitted(true)
    } catch (error) {
      const message = getAuthErrorMessage(
        error,
        t,
        "common.auth.reset.errors.requestFailed"
      )
      alertToast({
        title: t("common.auth.reset.errors.title"),
        description: message,
      })
    }
  }

  return (
    <div className="container flex min-h-[600px] items-center justify-center">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-center text-2xl">
            {t("common.auth.forgot.title")}
          </CardTitle>
          <CardDescription>
            {t("common.auth.forgot.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <div className="space-y-4 text-sm">
              <p>{t("common.auth.forgot.sent", { email: submittedEmail })}</p>
              <Button className="w-full" onClick={() => navigate("/login")}>
                {t("common.auth.actions.backToLogin")}
              </Button>
            </div>
          ) : (
            <div className="grid gap-4">
              <div className="grid gap-2">
                <Label htmlFor="email">{t("common.auth.fields.email")}</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
              <Button className="w-full" onClick={handleSubmit}>
                {t("common.auth.forgot.submit")}
              </Button>
              <Button
                className="w-full"
                variant="outline"
                onClick={() => navigate("/login")}
              >
                {t("common.auth.actions.backToLogin")}
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default ForgotPassword
